module.exports = {
  baseURL: window._env_?.REACT_APP_API_BASEURL,
  HomePage: "",
};